import TrainingList from "../../components/allTrainingList";
import * as Styled from "./styled";
import Sidemenu from "../../components/sidemenu";

const AdminPanel = () => {
  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Styled.ColumnDiv>
        <TrainingList />
      </Styled.ColumnDiv>
    </Styled.MainDiv>
  );
};

export default AdminPanel;
